import {
  getProductDiscount,
  getProductPriceInSells,
  getProductType,
} from "../../../_utils/utils";

export const nameSeller = (typeOfReport, totalSellsArray) =>
  typeOfReport === "sellsByUser"
    ? `Vendedor: ${totalSellsArray[0].user?.name}`
    : "";

export const siteName = (typeOfReport, totalSellsArray) =>
  typeOfReport === "sellsByUser" || typeOfReport === "sellsBySite"
    ? `Sucursal: ${totalSellsArray[0].site?.name}`
    : "";

export const totalPriceSells = (totalSellsArray) => {
  let totalPrice = 0;
  totalSellsArray.forEach((item) => {
    const price = getProductPriceInSells(item);
    const discount = getProductDiscount(item);
    if (!item.product.balance_transfer?.paymentPending)
      totalPrice += price - discount;
  });

  return totalPrice;
};

//MXN number formatter
export const formatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
});

export const getProductTypeCounterAccesory = (item) => {
  if (typeof item.payment_method?.name === "string") {
    return getProductType(item.product?.productTypeId);
  } else
    return `${getProductType(item.product?.productTypeId)} (${
      item.payment_method?.name
    }) `;
};
